export default __webpack_public_path__ + "static/media/hulu.b8d6fa55.webp";